import Accordion from './Accordion'
import AccordionSlider from './AccordionSlider'
import CollapseAccordion from './CollapseAccordion'
import CompaniesSearch from './CompaniesSearch'
import ClassToggle from './ClassToggle'
import footerNav from './footerNav'
import Fox from './Fox'
import Hamburger from './Hamburger'
import Header from './Header'
import Input from './Input'
import Map from './Map'
import Modal from './Modal'
import ModalOpener from './ModalOpener'
import ModalVideo from './ModalVideo'
import Nav from './Nav'
import NavLang from './NavLang'
import NavCollapse from './NavCollapse'
import NavLayer from './NavLayer'
import Parallax from './Parallax'
import Select from './Select'
import Slider from './Slider'
import FormToggle from './FormToggle'
import FakeAutocomplete from './FakeAutocomplete'
import ButtonClick from './ButtonClick'
import AdminPanel from './AdminPanel'
import ScrollToTarget from './ScrollToTarget'
import TypewriterOfflineVal from './TypewriterOfflineVal'
import TypewriterEncryptedWindow from './TypewriterEncryptedWindow'
import Typewritter from './Typewritter'
import PriceCounter from './PriceCounter'
import PriceStickyBar from './PriceStickyBar'
import Search from './Search'
import ContactSlider from './ContactSlider'
import GoogleMap from './GoogleMap'
import ReadProgress from './ReadProgress'
import TestimonialSlider from './TestimonialSlider'
import ItemsCorrection from './ItemsCorrection'
import TypewriterItems from './TypewriterItems'
import MenuToggler from './MenuToggler'
import DropdownSearch from './DropdownSearch'
import ContactForm from './ContactForm'
import ArticleAnchors from './ArticleAnchors'
import Countries from './Countries'
import CountriesSubForm from './CountriesSubForm'
import CompanySelect from './CompanySelect'
import PlatformSearch from './PlatformSearch'
import LoadMore from './LoadMore';
import EbookForm from './Ebook/EbookForm';
import EbookSecondForm from './Ebook/EbookSecondForm';
import RepairEmailForm from './RepairEmailForm';

const Components = {
	Accordion,
	AccordionSlider,
	CollapseAccordion,
	CompaniesSearch,
	ClassToggle,
	footerNav,
	Fox,
	Hamburger,
	Header,
	Input,
	Map,
	Modal,
	ModalOpener,
	ModalVideo,
	Nav,
	NavLang,
	NavCollapse,
	NavLayer,
	Parallax,
	Select,
	Slider,
	FormToggle,
	FakeAutocomplete,
	ButtonClick,
	AdminPanel,
	ScrollToTarget,
	TypewriterOfflineVal,
	TypewriterEncryptedWindow,
	Typewritter,
	PriceCounter,
	PriceStickyBar,
	Search,
	ContactSlider,
	GoogleMap,
	ReadProgress,
	TestimonialSlider,
	ItemsCorrection,
	TypewriterItems,
	MenuToggler,
	DropdownSearch,
	ContactForm,
	ArticleAnchors,
	Countries,
	CountriesSubForm,
	CompanySelect,
	PlatformSearch,
	LoadMore,
	EbookForm,
	EbookSecondForm,
	RepairEmailForm
}
export default Components
